export const STEP_HEADER_HEIGHT_BASE = 150;
export const STEP_HEADER_HEIGHT_MD = 100;
